module.exports = __webpack_public_path__ + "img/09c-authorize.5c589b16.png";